import React, { useEffect, useState } from 'react'
import CompactForm from './contractform'
import ContractFormTableComponent from "./table"
import { Container } from 'reactstrap'
import CompactFormEdit from './contractformEdit';
function ContractHomeTableForm() {
  const [dataVersion, setDataVersion] = useState(0); // Replace contractCreated with dataVersion
  const [copiedData, setCopiedData] = useState(null);
  const [isEditMode, setEditMode] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>(null)

  useEffect(() => {

    console.log("this the copied data ", copiedData)

  }, [copiedData])

  useEffect(() => {
    console.log("dataVersion updated:", dataVersion);
  }, [dataVersion]);

  return (
    <>
      <>
        <div>
          <div className="page-body">
            {isEditMode ? <Container fluid>
              <div className='table-ad'>
                <CompactFormEdit
                  dataVersion={dataVersion}
                  setDataVersion={setDataVersion}
                  isEditMode={isEditMode}
                  editedData={editedData}
                  setEditMode={setEditMode}

                />

              </div>
            </Container> : (
              <Container fluid>
                <div className='table-ad'>
                  <CompactForm
                    dataVersion={dataVersion}
                    setDataVersion={setDataVersion}
                    copiedData={copiedData}
                  />

                </div>
              </Container>
            )}

            <ContractFormTableComponent
              dataVersion={dataVersion}
              setDataVersion={setDataVersion}
              setCopiedData={setCopiedData}
              setEditMode={setEditMode}
              setEditedData={setEditedData}
            />
          </div>
        </div>
      </>

    </>

  )
}

export default ContractHomeTableForm